import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

export function useHasAnyAuthority(requiredAuthorities) {
  const authorities = useAppSelector(state => state.authentication.account.authorities);
  return requiredAuthorities.some(auth => hasAnyAuthority(authorities, [auth]));
}
